<template>
      <form-group :validator="v" :label="label" :label-for="id" :description="tip">
        <template slot-scope="{ attrs, listeners }">
            <v-select id="id" 
                :inputId="id"
                :options="options"
                :value="value"
                      label="text"
                @input="onSelected"
                @search="onSearch"
                aria-label="Search for Medical Facility" 
                screenreader="Search for Medical Facility" 
                :data-test="slug"
                :state="v.$dirty ? !v.$error : null"
                v-bind="attrs"
                v-on="listeners">
                <template slot="option" slot-scope="option">
                  {{ option.text }}
                </template>
                 <template slot="selected-option" slot-scope="option">
                    {{ option.text }}
                </template>
                <template #search="{attributes, events}">
                    <input
                        class="vs__search"
                        :required="!v.required"
                        v-bind="attributes"
                        v-on="events"
                        :state="v.$dirty ? !v.$error : null"
                        />
                </template>
            </v-select>            
        </template>
      </form-group>
</template>

<script>
import _ from "lodash"
import axios from "axios"

export default {
    props: {
        value: [Object],
        label: [String],
        tip: [String],
        slug: [String],
        v: [Object],
        required: [Boolean]
    },
    data() {
        return {
            options: [ ],
            defaultSelection: ''
        } 
    },
    computed: {
        id() {
            return _.uniqueId('facselector')
        },
        isRequired() {
            if (this.required == false) {
                return false
            } else {
                return !this.value.length
            }
        }
    },
    created() {
    },

    methods: {
        onSearch(search, loading) {            
            if (search && search.length > 1) {
                loading(true)
                this.search(loading, search, this)
            }
        },
        search: _.debounce((loading, search, vm) => {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/domain/facility/${escape(search)}`)
                .then((values) => {
                    vm.options = values.data
                    loading(false)
                })
          .catch((err)=>{
            console.log("We get an error",err)
            loading(false)
          })
            }, 350),

        onSelected(item) {
            this.$emit('input', item)
        },
  }
}
</script>

<style>
.vs__dropdown-menu {
    max-height:200px;
}
</style>